
interface EmailConfirmationNoticeProps {
    onResend: () => void;
    resending: boolean;
}

export default function EmailConfirmationNotice({ onResend, resending, }: EmailConfirmationNoticeProps) {
    return (
        <section className="mt-4 rounded-lg border border-background-200 bg-white p-4 sm:p-5">
            <div className="flex items-start gap-3">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i
                        className="ri-mail-warning-line text-xl"
                        aria-hidden="true"
                    />
                </div>

                <div className="min-w-0 flex-1">
                    <h2 className="font-heading text-base font-semibold text-foreground-950">
                        Adresse e-mail non confirmée
                    </h2>

                    <p className="mt-1 break-words text-sm text-foreground-500">
                        Confirme ton adresse e-mail pour sécuriser ton compte et accéder
                        aux fonctionnalités qui nécessitent une confirmation.
                    </p>

                    <button
                        type="button"
                        onClick={onResend}
                        disabled={resending}
                        className="mt-3 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-70"
                    >
                        {resending ? (
                            <>
                                <i
                                    className="ri-loader-4-line animate-spin"
                                    aria-hidden="true"
                                />
                                Envoi en cours...
                            </>
                        ) : (
                            <>
                                <i className="ri-mail-send-line" aria-hidden="true" />
                                Renvoyer l'e-mail de confirmation
                            </>
                        )}
                    </button>
                </div>
            </div>
        </section>
    );
}
